module.exports = __webpack_public_path__ + "static/img/icon.94ff243.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/1st/Articles/Article_4/icon.jpg
// module id = KrLr
// module chunks = 0